 document.addEventListener('DOMContentLoaded', function () {

   setTimeout(function () {
  const forms = document.querySelectorAll('form.ajax-add-to-cart-btn');

  forms.forEach(form => {

     const quantityInput = form.closest('.product-card').querySelector('.quantity-input');
   
   
  form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(form);
     formData.delete('properties[_for Delivery By]');
      

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(() => {
        // Update cart drawer content first, then open drawer
        updateCartDrawerContent()
          .then(() => {
            openCartDrawer();
            renderRecommendedForLastViewedProduct();
            renderRecentlyViewedProducts();
          });
      })
      .catch(err => console.error('Add to cart error:', err));
    });
  });
   },3000)

  function openCartDrawer() {
    const drawer = document.querySelector('#ajax-cart-drawer');
    if (drawer) {
      drawer.classList.add('sidebar-visible');
      drawer.style.display = 'flex';
      document.body.classList.add('cart-drawer-open'); 
    }

    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function updateCartDrawerContent() {

    return fetch('/?sections=header,ajax-cart-drawer')
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch cart drawer content');
        return res.json();
      })
      .then(rawHtml => {
        // const rawHtml = JSON.parse(html)
        const parser = new DOMParser();
        const doc = parser.parseFromString(rawHtml['ajax-cart-drawer'], 'text/html');
        const newContent = doc.querySelector('.cart-drawer-content');
        const currentDrawer = document.querySelector('.cart-drawer-content');

        // for bubble count
        const headerDoc = parser.parseFromString(rawHtml['header'], 'text/html');
        const newBubbleCount = headerDoc.querySelector('.header-icons-link.cart')
        const currentBubbleCount = document.querySelector('.header-icons-link.cart')
        if (newContent && currentDrawer) {
          currentDrawer.innerHTML = newContent.innerHTML;
          currentBubbleCount.innerHTML = newBubbleCount.innerHTML
          getQuantityElement(document.querySelector("[data-cart-drwaer-body]"));
          getCartItemRemoveElements(document.querySelector("[data-cart-drwaer-body]"))
        } else {
          console.error('Cart drawer element not found in fetched content or current page.');
        }
      })
      .catch(err => console.error('Error updating cart drawer:', err));
  }
});